import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=18207f4a&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=18207f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18207f4a",
  null
  
)

export default component.exports